import {observer} from 'mobx-react-lite'
import React, {useEffect, useRef, useState} from 'react'
import {DealActivityType, Hub} from 'yougile-model'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {useChatStore} from '@components/right-panel/chat/chat-store'
import {rightPanelStore} from '@components/right-panel/right-panel'
import {useForceUpdate, useSyncEvent} from '@containers/hooks'
import {DealTimeInputPanel} from './deal-time-input-panel/deal-time-input-panel'
import {DealTimeLineMessage} from './deal-time-line-message/deal-time-line-message'
import {DealTimeLinePlaceholder} from './deal-time-line-placeholder'
import {useDealTimeLineMessageData} from './use-deal-time-line-message-data'

export const DealHistory = observer(({hub}: {hub: Hub}) => {
  const scrollRef = useRef<HTMLElement | null>(null)
  const inputRef = useRef<HTMLInputElement>(null)
  const [, chatStore] = useChatStore()
  const forceUpdate = useForceUpdate()
  const [typeActivity, setTypeActivity] = useState<DealActivityType>('deal')

  const dealTimelineData = useDealTimeLineMessageData(hub)

  useSyncEvent(
    'current',
    {filter: hub?.id},
    () => {
      chatStore.syncOnUpdate()
      forceUpdate()
    },
    [hub?.id]
  )

  useEffect(() => {
    chatStore.syncOnNew(hub, true)
    if (!hub.chat?.messages?.size) {
      setTimeout(() => chatStore.syncOnUpdate(), 50)
    }
  }, [hub?.id])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight
      }
    }, 10)
    return () => clearTimeout(timeoutId)
  }, [hub?.id, dealTimelineData?.length])

  useEffect(() => {
    if (rightPanelStore.state.chatPanel.opened) {
      const timeoutId = setTimeout(() => {
        if (scrollRef.current) {
          scrollRef.current.scrollTop = scrollRef.current.scrollHeight
          inputRef?.current?.focus()
        }
      }, 100)
      return () => clearTimeout(timeoutId)
    }
    return undefined
  }, [rightPanelStore.state.chatPanel.opened])

  return (
    <div className="flex flex-col h-full min-h-0">
      <WithPerfectScrollbar
        className="flex-1 min-h-0 bg-background-secondary p-16"
        containerRef={el => {
          scrollRef.current = el
        }}
        options={{suppressScrollX: true}}
      >
        {!dealTimelineData.length && <DealTimeLinePlaceholder />}
        {dealTimelineData.map(activity => (
          <DealTimeLineMessage
            key={activity.id}
            deal={hub}
            activity={activity}
          />
        ))}
      </WithPerfectScrollbar>

      <DealTimeInputPanel
        ref={inputRef}
        hub={hub}
        typeActivity={typeActivity}
        setTypeActivity={setTypeActivity}
      />
    </div>
  )
})
